<template>
  <div class="sucPage">
    <div class="sbarBox">
      <img src="https://pohto-imgs.oss-cn-beijing.aliyuncs.com/uploads/2025/1106/320025FB40AC5888.jpg" alt="" />
    </div>

    <div class="allCon">
      <step :active="2"></step>
      <div class="tsBox">
      <div style="text-align: right;">NO.{{ visitorObj.trirdcode }}</div>
        <div class="topTxt" v-html="gconfig.SuccessPage"></div>
        <div class="successCon">
          <h3 style="font-weight: 500">{{ visitorObj.VisitorName }}</h3>
          <!--<p v-if="visitorObj.VistorRank">（{{ visitorObj.VistorRank }}）</p> -->
          <p v-if="visitorObj.VisitorComName" class="conname">
            {{ visitorObj.VisitorComName }}
          </p>
          <div class="qrMain">
            <div class="qrbox">
              <qrcode-vue
                :value="visitorObj.VistorVisCard"
                :size="100"
              ></qrcode-vue>
            </div>
          </div>
        </div>
      </div>
      <!-- 会议列表 -->
      <div class="meetingS">
        <!-- <h3>如需报名同期会议，请点击下方链接。</h3> -->
        <div class="opera">
          <div
            v-for="item in ops"
            :key="item.val"
            :class="{ operaItem: true, active: currentOp === item.val }"
            @click="changeOp(item.val)"
          >
            <div style="display: flex; align-items: center; padding-left: 7px">
              <img :src="item.img" style="width: 20px; height: 20px" alt="" />
              <span>{{ item.label }}</span>
            </div>
          </div>
        </div>
        <ul class="meetBox" v-if="currentOp === 'tq'">
          <li v-for="item in meetList" :key="item.name">
            <div class="itemWrap">
              <div class="itemCon">
                <h4>{{ item.name }}</h4>
                <div>
                  <span>
                    <van-icon class="hisIcon" name="clock-o" />
                    {{ item.date }}
                  </span>
                  <van-button
                    style="display: none;"
                    class="meetBtn"
                    round
                    :color="meetBtnColor"
                    type="primary"
                    size="mini"
                    native-type="submit"
                    :disabled="btnLoading"
                    :loading="btnLoading"
                    @click="toMeet(item.link)"
                  >
                    立即报名
                  </van-button>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul class="meetBox" v-if="currentOp === 'xz'">
          <li class="addBtnBox">
            <div class="button-group">
              <van-button
                :color="mainColor"
                size="normal"
                round
                class="custom-btn add-btn"
                @click="toadd">
                <van-icon name="plus" class="btn-icon" />直接添加
              </van-button>
              <van-button
                :color="secondaryColor || '#1989fa'"
                size="normal"
                round
                class="custom-btn share-btn"
                @click="shareadd">
                <van-icon name="share" class="btn-icon" />分享邀请
              </van-button>
            </div>
          </li>

          <li v-for="item in invisList" :key="item.visitorID">
            <div class="itemWrap">
              <div class="itemCon">
                <h4>{{ item.visitorName }}</h4>
                <div>
                  <h5>{{ item.visitorComName }}</h5>
                  <!--   <van-button
                    class="meetBtn"
                    round
                    :color="meetBtnColor"
                    type="primary"
                    size="mini"
                    native-type="submit"
                    :disabled="btnLoading"
                    :loading="btnLoading"
                  >
                    短信通知
                  </van-button> -->
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="currentOp === 'zt'">
          <div style="margin-bottom: 20px">
            <van-swipe
              class="my-swipe"
              :autoplay="3000"
              indicator-color="white"
            >
              <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                <img
                  :src="item.photoUrl"
                  style="width: 100%; height: 230px; object-fit: cover"
                />
              </van-swipe-item>
            </van-swipe>
          </div>
          <div>
            <img
              :src="require('@/assets/zt.png')"
              style="width: 100%; height: 40px"
              alt=""
            />
          </div>
          <div style="margin-top: 20px;display: none;">
            <div style="background: #fff; padding: 10px; border-radius: 10px">
              <div
                style="display: flex; align-items: center; margin-bottom: 10px"
              >
                <div
                  style="width: 4px; height: 15px; background: #02599f"
                ></div>
                <div style="padding-left: 10px">光伏</div>
              </div>
              <div
                v-for="(item, key) in actorList2"
                :key="item.id"
                v-show="key <= actorListShowNum2"
                style="
                  margin-bottom: 10px;
                  padding: 10px;
                  border-bottom: 1px solid #ccc;
                "
              >
                <div
                  @click="nvactor(item.uuid)"
                  style="display: flex; align-items: center"
                >
                  <img
                    :src="
                      item.logoUrl && item.logoUrl !== ''
                        ? item.logoUrl
                        : require('@/assets/company.png')
                    "
                    style="width: 50px; height: 20px"
                    alt=""
                  />
                  <div
                    style="
                      margin-left: 10px;
                      display: flex;
                      flex-direction: column;
                      justify-content: start;
                    "
                  >
                    <div style="font-weight: bold">{{ item.actorname }}</div>
                    <div style="font-size: 14px; text-align: left">
                      展位号:{{ item.boothNum }}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div
                    v-for="(t, index) in item.actorProducts"
                    :key="index"
                    v-show="index <= 2"
                    style="width: 33%; height: 130px; border-radius: 10px"
                  >
                    <img
                      :src="t.produtUrl"
                      @click="nvproduct(t.uuid)"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p style="margin-top: 20px" @click="toMore(2)">查看更多展商</p>
          </div>
          <div style="margin-top: 20px;display: none;">
            <div style="background: #fff; padding: 10px; border-radius: 10px">
              <div
                style="display: flex; align-items: center; margin-bottom: 10px"
              >
                <div
                  style="width: 4px; height: 15px; background: #02599f"
                ></div>
                <div style="padding-left: 10px;display: none;">储能</div>
              </div>
              <div
                v-for="(item, key) in actorList3"
                :key="item.id"
                v-show="key <= actorListShowNum3"
                style="
                  margin-bottom: 10px;
                  padding: 10px;
                  border-bottom: 1px solid #ccc;
                "
              >
                <div
                  @click="nvactor(item.uuid)"
                  style="display: flex; align-items: center"
                >
                  <img
                    :src="
                      item.logoUrl && item.logoUrl !== ''
                        ? item.logoUrl
                        : require('@/assets/company.png')
                    "
                    style="width: 50px; height: 20px"
                    alt=""
                  />
                  <div
                    style="
                      margin-left: 10px;
                      display: flex;
                      flex-direction: column;
                      justify-content: start;
                    "
                  >
                    <div style="font-weight: bold">{{ item.actorname }}</div>
                    <div style="font-size: 14px; text-align: left">
                      展位号:{{ item.boothNum }}
                    </div>
                  </div>
                </div>
                <div
                  style="
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div
                    v-for="(t, index) in item.actorProducts"
                    :key="index"
                    v-show="index <= 2"
                    style="width: 33%; height: 130px; border-radius: 10px"
                  >
                    <img
                      :src="t.produtUrl"
                      @click="nvproduct(t.uuid)"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p style="margin-top: 20px" @click="toMore(3)">查看更多展商</p>
          </div>
          <div style="margin-top: 20px">
            <div style="background: #fff; padding: 10px; border-radius: 10px">
              <div
                style="display: flex; align-items: center; margin-bottom: 10px"
              >
                <div
                  style="width: 4px; height: 15px; background: #02599f;display: none;"
                ></div>
                <div style="padding-left: 10px;display: none;">氢能</div>
              </div>
              <div
                v-for="(item, key) in actorList"
                :key="item.id"
                v-show="key <= actorListShowNum"
                style="
                  margin-bottom: 10px;
                  padding: 10px;
                  border-bottom: 1px solid #ccc;
                "
              >
                <div
                  @click="nvactor(item.uuid)"
                  style="display: flex; align-items: center"
                >
                  <img
                    :src="
                      item.logoUrl && item.logoUrl !== ''
                        ? item.logoUrl
                        : require('@/assets/company.png')
                    "
                    style="width: 50px; height: 20px"
                    alt=""
                  />
                  <div
                    style="
                      margin-left: 10px;
                      display: flex;
                      flex-direction: column;
                      justify-content: start;
                    "
                  >
                    <div style="font-weight: bold;text-align: left;">{{ item.actorname }}</div>
                    <div style="font-size: 14px; text-align: left">
                      展位号:<span style="font-weight: bold;color: #55A972;">{{ item.boothNum }}</span>
                    </div>
                    <div style="font-size: 12px; text-align: left">
                      <span
              v-if="item.actorProducts && item.actorProducts.length > 0"
              class="product-names"
            >
              主营产品： {{ item.actorProducts.map(product => product.productName).join('、') }}
            </span>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                >
                  <div
                    v-for="(t, index) in item.actorProducts"
                    :key="index"
                    v-show="index <= 2"
                    style="width: 33%; height: 130px; border-radius: 10px"
                  >
                    <img
                      :src="t.produtUrl"
                      @click="nvproduct(t.uuid)"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
            </div>
            <p style="margin-top: 20px" @click="toMore(1)">查看更多展商</p>
          </div>
        </div>
      </div>
    </div>
    <div v-html="gconfig.SuccessPageBottomText"></div>
    <div class="shMask" v-show="showSh">
      <img :src="gconfig.Banner" style="width: 100%" alt="" />
      <div class="shConBox">
        <div class="shDiv">
          <img :src="shIcon" alt="" />
          <h3>审核中</h3>
          <div v-html="shContent" class="shTxt"></div>
        </div>
      </div>
    </div>
    <!-- 身份证 -->
    <div class="shMask" v-show="showVerCard">
      <img :src="sbar" style="width: 100%" alt="" />
      <div>
        <p style="padding: 15vw 0 8vw; font-size: 1.2em; font-weight: 600">
          请您补充证件号码，完成实名认证！
        </p>
        <van-form @failed="onFailed" @submit="onSubmit">
          <van-cell-group>
            <!-- 姓名 -->
            <van-field
              v-model="formMg.Name"
              Name="Name"
              label="姓名"
              :rules="rulesAll.Name"
              class="requiredItem"
            />
            <!-- 身份证号 -->
            <van-field
              class="requiredItem"
              v-model="formMg.IDCardNo"
              Name="IDCardNo"
              label="身份证号"
              :rules="rulesAll.IDCardNo"
            />
          </van-cell-group>
          <div style="margin: 16px">
            <van-button
              round
              style="width: 45%"
              :color="mainColor"
              type="primary"
              native-type="submit"
              :disabled="btnLoading"
              :loading="btnLoading"
            >
              下一步
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
  <!-- 微信分享提示 -->
  <div class="shareModel" v-if="showShareModel">
    <img :src="wxshare" @click="closeShareModel" />
  </div>
  <!-- ... 其他代码 ... -->
  <div class="floating-btn" @click="openMiniProgram" v-if="ismini">
    <img src="@/assets/mini-program-icon.jpeg" alt="回到首页" />
  </div>
   <van-popup
    v-model:show="formVisible"
    closeable
    position="bottom"
    @click-close-icon="closerequire"
    style="max-height: 70vh; overflow-y: auto;"
  >
    <div>
      <div style="box-shadow: 0 2px 4px rgba(0,0,0,0.1); padding: 10px; margin-bottom: 10px;">
            <h3 class="favoTit">请填写采购需求清单</h3>
            </div>
      <van-form @submit="onSubmitS">
        <van-cell-group inset>
          <van-field
            v-model="newForm.requirename"
            type="textarea"
            name="requirename"
            label="产品名称或更多要求"
            placeholder="请填写您需要采购的产品名称和要求，越详细越容易精准匹配契合的供应商"
            :rules="newRule.requirename"
            required
            :autosize="{ minHeight: 100, maxHeight: 200 }"
            class="textarea-field"
            label-align="top"
          />
          <van-field
            class="uploadFile"
            name="requirepic"
            label="需求图片/视频"
            placeholder="点击上传图片/视频"
            :rules="newRule.requirepic"
          >
            <template #input>
              <van-uploader
                v-model="newForm.requirepic"
                :before-read="beforeRead"
                :after-read="afterRead"
                :max-count="1"
                accept="image/*,video/*"
                upload-text="选择文件"
              />
            </template>
          </van-field>
        </van-cell-group>
        <div style="margin: 16px">
          <van-button round block type="primary" native-type="submit" :color="btnColor">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
  <van-popup
          v-model:show="favoVisible"
          closeable
          position="bottom"
          @click-close-icon="closeFavo"
        >
          <div class="favoCon">
            <div style="box-shadow: 0 2px 4px rgba(0,0,0,0.1); padding: 10px; margin-bottom: 10px;">
            <h3 class="favoTit">欢迎您使用商贸邀约对接服务</h3>
            <div style="font-size:12px;text-align: left;padding-left: 1em;padding-right: 1em;color:#666">
                致力于链动全球贸易，提供专业的线上线下智能营销解决方案以及精准供需对接服务，全面提升成交效率。
            </div>
            <div class="selected-display"  style="font-size:14px;margin-top:5px;">
    <div class="selected-info">
      <span class="selected-icon">🎯</span>
      <span class="selected-text" style="font-weight: 700">
        已选择拜访
        <span style="color: red;">{{ selectedCount }}</span>
        家优质参展商，加入商机日历日程，并交换名片
      </span>
    </div>
  </div>
  </div>
            <div class="favoListBox" style="margin-top:15px;">
              <van-checkbox-group v-model="favoChecked">
                <div style="text-align: left;padding-left: 1em;font-weight: 700;">
                本届甄选展商・必打卡推荐
              </div>
                <ul>
                  <li
  class="favoItem"
  v-for="item in favoData"
  :key="item.actorID"
>
  <div class="favoItemMsg" @click="nvactor(item.uuid)" style="position: relative;">
    <div class="imgBox">
      <img :src="item.logoUrl" v-if="item.logoUrl" />
      <!-- <span v-else>无图</span> -->
      <img v-else :src="company" />
    </div>

    <div class="atrName">
      <p>{{ item.actorname }}</p>
      <p class="bthNum">
        展位号：<span>{{ item.boothNum }}</span>
      </p>
      <p>
        <span
          v-if="item.actorProducts && item.actorProducts.length > 0"
          class="product-names"
          :title="item.actorProducts.map(product => product.productName).join('、')"
        >
          主营产品： {{ item.actorProducts.map(product => product.productName).join('、') }}
        </span>
      </p>
      <div class="product-images-container">
        <div class="product-images">
          <img
            v-for="(it, index) in item.actorProducts"
            :key="index"
            :src="it.produtUrl"
            :alt="it.name || '产品图片'"
            class="product-image"
          />
        </div>
      </div>
    </div>
    <van-checkbox
      :name="item.actorID"
      :checked-color="mainColor"
      shape="square"
      style="position: absolute; top: 0; right: 0;"
    ></van-checkbox>
  </div>
</li>
                </ul>
              </van-checkbox-group>
            </div>
            <div class="favo-btm-box">
              <van-button
                :color="btnColor"
                type="primary"
                round
                @click.stop="favoConfirm"
              >
                加入日程并交换名片
              </van-button>
                <div style="color: #666;font-size:12px;margin-top:5px;" @click="favoCancel">下次再选</div>
            </div>
          </div>
        </van-popup>
        <!-- 自定义确认弹窗 -->
<!-- 在模板中的其他 van-popup 后面添加确认弹窗 -->
<van-popup v-model:show="showConfirmModal" round closeable :style="{ width: '80%' }">
  <div class="confirm-modal-content">
    <div class="confirm-title">提示</div>
    <div class="confirm-message">放弃与优质展商会面日程？</div>
    <div class="confirm-buttons">
      <van-button
        class="confirm-btn-cancel"
        @click="confirmSkip"
      >
        是
      </van-button>
      <van-button
        class="confirm-btn-confirm"
        :color="btnColor"
        @click="closeConfirmModal"
      >
        否
      </van-button>

    </div>
  </div>
</van-popup>
</template>
<script setup>
// import { Image } from 'vant'
import shIcon from '@/assets/shIcon.png'
import sbar from '@/assets/vis/sbar.png'
// import defultcompanylogo from '@/assets/company.png'
import { ref, computed, onMounted, watch } from 'vue'
import api from '@/api'
import { useStore } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import step from '@/components/step.vue'
import wwx from '@/utils/wx.js'
import wxshare from '@/assets/wxshare.png'
// import www from 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
// import wx from 'weixin-js-sdk'
import { decryptionECB } from '@/utils/utils.js'
import { validatorName } from '@/utils/validators.js'
import { regCId } from '@/utils/regs.js'
import { useRoute, useRouter } from 'vue-router'
import { showFailToast } from 'vant'
const btnColor = ref(
  'linear-gradient( 90deg, #02599F 0%, #55A972 80%,  #A1C98B 100%)'
)
const secondaryColor = ref('#99c288')
const showShareModel = ref(false)
const selectedCount = ref(0)
const route = useRoute()
const shareadd = () => {
  showShareModel.value = true
}
const closeShareModel = () => {
  showShareModel.value = false
}
const ismini = ref(false)
const router = useRouter()

const ops = [
  // eslint-disable-next-line quotes
  { label: '推荐展商', val: 'zt', img: require('@/assets/3.png') },
  { label: '同期会议', val: 'tq', img: require('@/assets/2.png') },
  { label: '协助注册', val: 'xz', img: require('@/assets/1.png') }
]

// 显示卖家列表
const favoVisible = ref(false)
const favoChecked = ref([])
const favoData = ref([])
// 添加确认弹窗显示状态
const showConfirmModal = ref(false)
// 监听 favoChecked 数组变化来更新 selectedCount
watch (favoChecked, (newVal) => {
  selectedCount.value = newVal.length
})
const showFavo = async () => {
  console.log('222222222')
  favoVisible.value = true
  const res = await api.favoListApi({ ExhCode: ExhCode.value })
  if (res.code === 200) {
    favoData.value = res.data
  }
}
const closeFavo = () => {
  favoVisible.value = false
  favoChecked.value = []
}
const closerequire = () => {
  showFavo()
}
const favoConfirm = () => {
  console.log('favoConfirm called', selectedCount.value)
  if (selectedCount.value === 0) {
    console.log('showing fail toast')
    showFailToast('请选择优质参展商')
    console.log('1111111')
    return
  }
  console.log('closing favo popup')
  favoVisible.value = false
  // 添加接口
  const params = {
    FavoriteSeller: favoChecked.value.join(','),
    visitorid: VisitorID.value
  }
  console.log(JSON.stringify(params), 'kkkkk')
  const res = api.savefavoriteApi(params)
  if (res.code === 200) {
    favoVisible.value = false
  }
}
const favoCancel = () => {
  showConfirmModal.value = true
}

// 关闭确认弹窗
const closeConfirmModal = () => {
  showConfirmModal.value = false
}

// 确认跳过选择
const confirmSkip = () => {
  // 关闭确认弹窗
  showConfirmModal.value = false
  // 关闭卖家选择弹窗
  favoVisible.value = false
}

const toMeet = (linkurl) => {
  window.location.href = linkurl
}
const toadd = () => {
  router.push({ path: '/msgH' })
}
const myinvite = () => {
  router.push({ path: '/myInvite' })
}
// 获取邀请列表
const invisList = ref([])
const getVis = async () => {
  const res = await api.GetVisitorListApi({
    exhcode: ExhCode.value,
    VisitorID: VisitorID.value
  })
  invisList.value = res.data
}
const currentOp = ref('zt')

const changeOp = (type) => {
  currentOp.value = type
  if (type === 'xz') {
    getVis()
  }
  if (type === 'zt') {
    getzt()
  }
}

const actorList = ref([]) // 氢能
const actorList2 = ref([]) // 光伏
const actorList3 = ref([]) // 储能
const actorListShowNum = ref(2)
const actorListShowNum2 = ref(2)
const actorListShowNum3 = ref(2)
const toMore = (type) => {
  if (type === 1) {
    actorListShowNum.value = actorList.value.length
  }
  if (type === 2) {
    actorListShowNum2.value = actorList2.value.length
  }
  if (type === 3) {
    actorListShowNum3.value = actorList3.value.length
  }
}
const getzt = async () => {
  const res = await api.getactorlistApi({
    exhcode: ExhCode.value,
    type: '氢能'
  })
  actorList.value = res.data
  const res1 = await api.getactorlistApi({
    exhcode: ExhCode.value,
    type: '光伏'
  })
  actorList2.value = res1.data
  const res2 = await api.getactorlistApi({
    exhcode: ExhCode.value,
    type: '储能'
  })
  actorList3.value = res2.data
  console.log(actorList.value, '展商')
  // getBanner()
}

// 获取轮播图
const bannerList = ref([])
// const getBanner = async () => {
//   const res = await api.getBannerApi({
//     exhcode: ExhCode.value
//   })
//   bannerList.value = res.data
//   console.log(bannerList.value, '轮播图')
// }
const btnLoading = ref(false)
const store = useStore()
const ExhCode = computed(() => store.state.ExhCode)
const gconfig = computed(() => getConfigObj(store.state.gconfig))
const getConfigObj = (configStr) => {
  const configObj = {}
  if (configStr) {
    const resObj = JSON.parse(decryptionECB(configStr))
    resObj.forEach((item) => {
      configObj[item.GlobalKey] = item.GlobalValue
    })
  }
  return configObj
}
const mainColor = computed(() => store.state.mainColor)
// console.log(gconfig.value, '222222222')
const VisitorID = computed(() => store.state.VisitorID)
const isWeX = computed(() => store.state.isWeX)
if (/micromessenger/i.test(navigator.userAgent)) {
  store.commit('setIsWeX', true)
}
const meetList = ref([
  {
    name: '2026年光伏市场发展论坛',
    date: '3月26日（北京･国会一期)',
    link: 'https://reg.richtimes.com.cn/MicroWebsite/25ceec/#/indexA3?aid=96M-1MD&pageType=A3'
  },
  {
    name: '第四届中国储能大会',
    date: '3月25日（北京･国会一期)',
    link: 'https://reg.richtimes.com.cn/MicroWebsite/25ceec/#/indexA4?aid=91363N3&pageType=A4'
  },
  {
    name: 'CIHC 2026国际氢能大会',
    date: '3月25日-26日（国会一期、二期)',
    link: 'https://xb29949609.m.jzfkw.net'
  }
])
const meetBtnColor = ref(
  'linear-gradient(90deg, #02599F 0%, #55A972 80%,  #A1C98B 100%)'
)
const visitorObj = ref({})
// 是否显示审核
const showSh = ref(false)
// 审核显示内容
const shContent = ref('')
const getMsg = async () => {
  const res = await api.getVisitorApi({ VisitorID: VisitorID.value })
  const jmRes = JSON.parse(decryptionECB(res.data))
  visitorObj.value = jmRes
  console.log(visitorObj.value)
  // 判断是否显示审核
  if (gconfig.value.IsNeedCheck === 'True') {
    if (
      visitorObj.value.VisitorCheckSysstate === null ||
      visitorObj.value.VisitorCheckSysstate === '' ||
      visitorObj.value.VisitorCheckSysstate === '审核未通过'
    ) {
      showSh.value = true
      if (
        visitorObj.value.VisitorCheckSysstate === null ||
        visitorObj.value.VisitorCheckSysstate === ''
      ) {
        shContent.value = gconfig.value.WaitCheckContent
      } else {
        shContent.value = gconfig.value.CheckFailContent
      }
      return false
    } else {
      showSh.value = false
    }
  }
  if (gconfig.value.IsNeedIDCard === 'True') {
    // 是否需要补实名
    console.log(visitorObj.value.VisitorIDCard, '身份证')
    if (!visitorObj.value.VisitorIDCard) {
      // 如果没有身份证
      showVerCard.value = true
      // btnLoading.value=true
      formMg.value.Name = visitorObj.value.VisitorName
      return false
    }
    showVerCard.value = false
  }
  showSh.value = false
}
// 表单显示判单
const formVisible = ref(false)
if (route.query.isReg) {
  formVisible.value = true
}
onMounted(() => {
  getMsg()
  if (isWeX.value) {
    wwx.getWXSign()
  }
  getzt()
  console.log(/miniprogram/i.test(navigator.userAgent), 'useragent')
  if (/miniprogram/i.test(navigator.userAgent)) {
    ismini.value = true
  }
  if (store.state.isWeX) {
    // 初始化微信JS-SDK
    wwx
      .getWXSign()
  }
})
const newForm = ref({
  requirename: '',
  requirepic: []
})
const newRule = ref({
  requirename: [
    { required: true, message: '请填写您需要采购的产品名称和要求' }
  ]
})
const showPPicker = ref(false)
// 获取产品类型字典
const pChecked = ref([])
const pDict = ref([])

const showPChoose = () => {
  showPPicker.value = true
  pChecked.value = newForm.value.requiretypeIds
    ? newForm.value.requiretypeIds.split('|')
    : []
}
// 确认选择
const confirmP = () => {
  const choosePArr = []
  pDict.value.forEach((item) => {
    if (pChecked.value.indexOf(item.dictValue) > -1) {
      choosePArr.push(item)
    }
  })
  newForm.value.requiretypeName = choosePArr
    .map((item) => item.dictLabel)
    .join('|')
  console.log(pChecked.value, 'kkkkkkkkkk')
  newForm.value.requiretypeIds = pChecked.value.join('|')
  showPPicker.value = false
}
const beforeRead = (file) => {
  const isImage = /image\/(jpeg|png|jpg)/.test(file.type)
  const isVideo = /video\/(mp4|mov|avi)/.test(file.type)
  if (!isImage && !isVideo) {
    Toast.fail('请上传图片或视频文件')
    return false
  }
  if (file.size > 5 * 1024 * 1024) {
    Toast.fail('文件大小不能超过5MB')
    return false
  }
  return true
}
const afterRead = async (file) => {
  // 处理上传后的文件
  console.log('上传文件:', file.file)
  const formData = new FormData()
  formData.append('file', file.file)
  const res = await api.fileUploadApi(formData)
  if (res.code === 200) {
    newForm.value.requirepic = [{ url: res.data.imageUrl }]
  }
}
const onSubmitS = async () => {
  const {
    requirename,
    requirepic
  } = newForm.value
  const params = {
    requirename,
    requirepic: requirepic && requirepic.length > 0 ? requirepic[0].url : '',
    visitorid: VisitorID.value,
    ExhCode: ExhCode.value
  }
  console.log(JSON.stringify(params), 'kkkkk')
  const res = await api.saveSApi(params)
  if (res.code === 200) {
    formVisible.value = false
    showFavo()
  }
}
const showVerCard = ref(false)
const formMg = ref({
  Name: '',
  IDCardNo: ''
})
// 校验证件号
const validatorIDCardNo = (val) => {
  return regCId(val)
}
const rulesAll = ref({
  Name: [
    { required: true, validator: validatorName, message: '请输入正确的姓名' }
  ],
  IDCardNo: [{ validator: validatorIDCardNo, message: '请输入正确的身份证号' }]
})
// 表单验证失败
const onFailed = (errorInfo) => {
  console.log('failed', errorInfo)
}
const onSubmit = async (values) => {
  const res = await api.UpdateIDcardApi({
    VisitorID: VisitorID.value,
    Name: formMg.value.Name,
    IDCardNo: formMg.value.IDCardNo,
    exhcode: ExhCode.value
  })
  if (res.code === 200) {
    getMsg()
  }
}

const openMiniProgram = () => {
  wx.miniProgram.reLaunch({
    url: '/pages/index/index',
    // url:'/pages/company/company/detail/companyDetail?companyGuid=4ee65867dd7b4e8884e197b51c56a21b',
    fail: function (res) {
      console.log('fail', res)
    },
    success: function (res) {
      console.log('success', res)
    }
  })
}

const nvactor = (uuid) => {
  wx.miniProgram.navigateTo({
    url: '/pages/company/company/detail/companyDetail?companyGuid=' + uuid
  })
}
// nvproduct
const nvproduct = (uuid) => {
  wx.miniProgram.navigateTo({
    url: '/pages/company/exhibits/detail/exhibitsDetail?exhibitsGuid=' + uuid
  })
}
</script>
<style lang="less">
@import '../../assets/login.less';
.product-names {
  font-size: 0.7rem;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.product-images-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-top: 8px;
  /* 隐藏滚动条但保持功能 */
}

.product-images-container::-webkit-scrollbar {
  display: none;
}

.product-images {
  display: flex;
  gap: 8px;
  padding: 4px 0;
  width: max-content;
  /* 防止内容溢出到页面上 */
  max-width: 100%;
}

.product-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}
/* 在样式部分添加确认弹窗样式 */
.confirm-modal-content {
  padding: 20px;
  text-align: center;
}

.confirm-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.confirm-message {
  font-size: 16px;
  margin-bottom: 20px;
  color: #333;
}

.confirm-buttons {
  display: flex;
   justify-content: space-around;
  gap: 20px; /* 添加按钮间的间隔 */
}

.confirm-btn-cancel, .confirm-btn-confirm {
  width: 40%;
}
.favobox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3vw;
  background: #fff2f4;
  .favoL {
    text-align: left;
    h3 {
      font-size: 1em;
      color: #783651;
      padding-bottom: 1vw;
    }
    p {
      color: #712c49;
      font-size: 0.9em;
    }
    span {
      font-size: 0.7em;
      color: #817e7e;
    }
  }
}
.favoCon {
  .favoTit {
    font-size: 1em;
    padding: 3vw 0;
    text-align: left;
    text-indent: 1em;
    color:#481425;
  }
  .favoListBox {
    height: 120vw;
    overflow: scroll;
    padding-bottom: 22vw;
  }
  ul {
    width: 92%;
    margin: 0 auto;
    .favoItem {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  border: 1px solid #ececec;
  padding: 2vw;
  margin-bottom: 2vw;
  border-radius: 8px;
    flex: 1;
    min-width: 0; /* 允许内容收缩 */
    .favoItemMsg {
      display: flex;
      width:100%;
      .imgBox {
        width: 15vw;
        height: 15vw;
        padding: 1vw;
        border: 1px solid #ececec;
        margin-right: 2vw;
        flex-shrink: 0; /* 防止图片区域被压缩 */
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      .atrName {
        max-width: 80%;
        flex: 1;
        min-width: 0; /* 允许内容收缩 */
        text-align: left;
        p {
          font-size: 0.9em;
          word-wrap: break-word; /* 允许长文本换行 */
        }
        .bthNum {
          font-size: 0.7rem;
          color: #817e7e;
          padding-top: 1vw;
          span {
            font-weight: bold;
            color: #55A972;
          }
        }
      }
    }
  .favo-checkbox {
    margin-left: 10px;
    margin-top: 1vw;
    flex-shrink: 0; /* 防止复选框被压缩 */
  }
}
  }
  .favo-btm-box {
    position: fixed;
    bottom: 0;
    padding: 3vw 5vw;
    left: 0;
    width: 100%;
    background: #fff;
    height: 20vw;
  }
}
.uploadFile {
  .van-field__body {
    border: 0;
    height: auto;
  }
}
.custom-textarea {
  .van-cell__value {
    textarea {
      border: 1px solid #f2f2f2 !important; /* 统一边框样式 */
      border-radius: 4px;
      padding: 8px 12px;
    }
  }
}
// 针对van-field__body的样式调整，解决边框遮挡问题
.no-border-field {
  .van-field__control {
    textarea {
      border: 1px solid #e8e8e8 !important;
      border-radius: 4px;
    }
  }

  .van-field__body {
    border: none !important;
    outline: none !important;
  }

  .van-cell {
    &::after {
      display: none !important;
    }
  }
}
// 专门处理文本域的样式，去掉van-field__body边框且不遮挡label
.textarea-field {
  padding-bottom: 12px !important;

  // 去掉van-field__body的边框
  .van-field__body {
    border: none !important;
    box-shadow: none !important;
    height: auto !important;
  }

  // 给textarea添加边框和间距
  textarea {
    border: 1px solid #999999 !important;
    border-radius: 4px !important;
    padding: 8px 12px !important;
    margin-top: 8px !important;
  }

  // 隐藏默认的底部边框线
  .van-cell::after {
    display: none !important;
  }

  .van-field__control {
    &::after {
      display: none !important;
    }
  }
}
.shareModel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  z-index: 9999;
  img {
    width: 66%;
    margin-top: 20vw;
  }
}
.floating-btn {
  position: fixed;
  bottom: 120px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: rgba(255, 255, 255, 0.8); /* 半透明背景 */
  border-radius: 50%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;

  img {
    width: 120px;
    height: 120px;
  }
}
.sucPage {
  .sbarBox {
    img {
      width: 100%;
    }
  }
  .van-popup {
    .van-cell {
      &::after {
        display: none !important;
      }

      .van-field__control--textarea {
        textarea {
          border: 1px solid #e8e8e8 !important;
          border-radius: 4px !important;
          box-shadow: none !important;
        }
      }

      .van-field__body {
        border: none !important;
        box-shadow: none !important;
      }
    }
  }
  .allCon {
    border-radius: 30px 30px 0 0;
    border-radius: 8vw;
    overflow: hidden;
    margin-top: -7.5vw;
    background: #f6f6f6;
    position: relative;
    padding: 3vw 3vw;
    .stepBox {
      width: 100%;
    }
    .tsBox {
      background: #fff;
      border-radius: 20px;
      padding: 5vw 3vw;
      box-shadow: 0px 0px 5px #cecece;
      margin-top: 20px;
    }
  }
}
.meetingS {
  margin: 10px auto;
  .opera {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 0;
    .operaItem {
      padding: 1px;
      border-radius: 12px;
      width: 31%;
      > div {
        background: #fff;
        border-radius: 10px;
        padding: 12px 0;
        span {
          color: #000000;
          font-weight: bold;
        }
      }
    }
    .operaItem.active {
      background: linear-gradient(to right, #02599f, #a1c98b);
    }
  }
  h3 {
    color: #191919;
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    border-bottom: 1px solid;
    border-image-source: linear-gradient(to right, #02599f, #a1c98b);
    border-image-slice: 1;

    padding-bottom: 2vw;
    margin-bottom: 5vw;
    margin-top: 25px;
  }

  .meetBox {
    li {
      background: linear-gradient(180deg, #02599f, #a1c98b);
      padding: 1px;
      border-radius: 12px;
      margin-bottom: 3vw;
      .itemWrap {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0px 0px 10px #ececec;
        padding: 4vw 3vw;
        text-align: left;
        display: flex;
        align-items: center;
        background: #fff;
        &::before {
          content: ' ';
          display: inline-block;
          width: 1vw;
          height: 10vw;
          background: linear-gradient(180deg, #02599f, #a1c98b);
          border-radius: 0.5vw;
          margin-right: 2vw;
        }
        h4 {
          color: #4d4d4d;
          font-size: 16px;
          font-weight: 600;
          padding-bottom: 4px;
        }
        .itemCon {
          width: 100%;

          > div {
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            > span {
              color: #191919;
              font-size: 13px;
              .hisIcon {
                margin-right: 3px;
              }
            }
          }
        }
      }
    }
    .addBtnBox {
      background: transparent;
      text-align: right;
      .addMemBtn {
        padding-bottom: 10px;
      }
    }
  }
  .meetBtn {
    color: #fff !important;
    padding: 0 10px;
  }
}
.shConBox {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f9f9f9;
  .shDiv {
    position: absolute;
    top: 35%;
    left: 50%;
    margin-top: -50%;
    margin-left: -40%;
    width: 80%;
    background: #fff;
    box-shadow: 0px 0px 10px #eee;
    border-radius: 10px;
    padding: 8vh 0 15vh;
    h3 {
      text-align: center;
      color: #18bae5;
      font-size: 16px;
      padding: 2vh 0;
    }
    img {
      width: 30%;
    }
    .shTxt {
      text-align: left !important;
      font-size: 14px;
      line-height: 28px;
      color: #000;
      padding: 0 5vw;
    }
  }
}
.topTxt {
  padding: 0 10px;
  p {
    padding: 6px 0;
    color: #323233;
    font-size: 14px;
  }
}
.iconbox {
  text-align: center;
  padding-top: 5vh;
  img {
    width: 42vw;
  }
}
.btnbox {
  text-align: center;
  padding: 2vh 0 0 0;
}
.tipsTxt {
  color: #2090be;
  font-weight: bold;
  padding-top: 20px;
}
.qrMain {
  display: flex;
  justify-content: center;
  padding-top: 3px;
  .qrbox {
    display: inline-block;
    // padding: 32px;
    border-radius: 12px;
    // box-shadow: 0px 0px 10px #ccc;
    padding: 3vw;
    background: linear-gradient(180deg, #02599f, #a1c98b);
    canvas {
      padding: 1.5vw;
      border-radius: 8px;
      background: #fff;
      display: block;
    }
  }
}
.successCon {
  /* padding: 20px 0 30px;*/
  background: #fff;
  width: 90%;
  margin: 10px auto;
  border-radius: 6px;
  p,
  h3 {
    padding: 2px 0;
  }
  h3 {
    font-size: 18px;
  }
  .conname {
    font-size: 12px;
  }
}
.shMask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 2;
}
@media screen and (min-width: 768px) {
  .sucPage {
    .sbarBox {
      margin-top: -160px;
    }
    .allCon {
      border-radius: 20px;
      padding: 20px 100px;
      margin-top: -3vw;
      .tsBox {
        padding: 1vw 3vw;
      }
    }
  }
  .qrMain {
    .qrbox {
      padding: 10px;
      canvas {
        padding: 8px;
      }
    }
  }
  .meetingS {
    h3 {
      padding-bottom: 10px;
      margin-bottom: 20px;
    }
    .meetBox {
      li {
        margin-bottom: 20px;
        .itemWrap {
          padding: 25px 12px;
          &::before {
            width: 6px;
            height: 50px;
          }
        }
      }
    }
  }
}
.sucPage .addBtnBox {
  display: flex;
  justify-content: center;
  margin: 25px 0;
  padding: 0 15px;
}

.button-group {
  display: flex;
  gap: 20px;
  width: 100%;
  max-width: 320px;
  justify-content: space-between;
}

.custom-btn {
  flex: 1;
  height: 44px;
  font-weight: 500;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加轻微阴影 */
  transition: all 0.3s ease; /* 平滑过渡效果 */
  position: relative;
  overflow: hidden;
}

.custom-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(255,255,255,0.3), rgba(255,255,255,0));
  pointer-events: none;
}

.custom-btn:active {
  transform: translateY(1px); /* 点击时下沉效果 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-btn {
  border: none;
}

.share-btn {
  border: none;
}

.btn-icon {
  vertical-align: middle;
  margin-right: 5px;
  font-size: 16px;
}
</style>
